module.exports = "/static/assets/954e7a4e804e25fa93747c0f4f46f5ba.png";